import { DataBean } from "../DataBean";

export class PaymentFile extends DataBean {
  public async getPaymentFileCatalog(id: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getPaymentFileCatalog_Number",
      [id]
    );
  }

  public async getPaymentFileCatalogByProcessType(
    processType: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getPaymentFileCatalogByProcessType_Number",
      [processType]
    );
  }

  public async updatePaymentFile(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "admin.PaymentFile_updatePaymentFile_admin.PaymentFile",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "admin.PaymentFile",
        },
      ]
    );
  }

  public async deletePaymentFile(idPaymentFile: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deletePaymentFile_Number",
      [idPaymentFile]
    );
  }

  public async getPaymentFile(idPaymentFile: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "admin.PaymentFile_getPaymentFile_Number",
      [idPaymentFile]
    );
  }
}
